export default {
  clientId: process.env.REACT_APP_SSO_AZURE_MEDTRONIC_CLIENT_ID as string,
  authority: process.env.REACT_APP_SSO_AZURE_MEDTRONIC_AUTHORITY_URL as string
};
